// Versão do app - gerado automaticamente
export const APP_VERSION = '5.23'
export const BUILD_DATE = '24/01/2026, 09:25'
